export const playerSelector = (state) => state.player;
